import { render, staticRenderFns } from "./TabFormList.vue?vue&type=template&id=c2395b0c"
import script from "./TabFormList.vue?vue&type=script&lang=js"
export * from "./TabFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports